































import { ElStep } from 'element-ui/types/step';
import { Vue, Component } from 'vue-property-decorator';
import store from '../../vuex/modules/login';
const gif = require('@/assets/img/401.gif');

@Component
export default class Page401 extends Vue {
    public errGif = gif;
    created() {}
    back() {
        this.$router.back();
    }
    goLogin() {
        let dayChecked = localStorage.getItem('dayChecked')
        if(dayChecked=='true'){
            localStorage.clear();
        }else{
            sessionStorage.clear();
        }
        location.reload();
        this.$router.push('/login');
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/errorPage/401.vue